export const GET_TOP = 'GET_TOP' as const
export const GET_TOP_SUCCEEDED = 'GET_TOP_SUCCEEDED' as const
